var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcFog(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.074 4.5c-2.836 0-4.324 1.429-4.984 2.354-1.362-.238-3.589-.195-5.223 1.439-.871.871-1.346 1.617-1.584 2.282-.054.15-.094.292-.124.425H.074v2H13.55v-2H4.274c.157-.309.45-.735 1.007-1.293 1.13-1.13 2.894-1.064 3.845-.799a1.23 1.23 0 0 0 1.413-.607C10.736 7.93 11.63 6.5 14.074 6.5c1.324 0 2.178.584 2.725 1.334.578.79.808 1.765.79 2.417a1.21 1.21 0 0 0 1.206 1.249h.28c.53 0 1.332.147 1.966.546.58.366 1.033.94 1.033 1.954 0 2.196-1.499 3-2.5 3h-17.5v2h17.5c1.999 0 4.5-1.596 4.5-5 0-1.786-.88-2.962-1.967-3.646-.845-.533-1.801-.765-2.56-.832a6.281 6.281 0 0 0-1.133-2.868c-.883-1.21-2.311-2.154-4.34-2.154zm-7 9.5h-1v2H19.55v-2H7.074z",
    fill: "#313030"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFog);
export default __webpack_public_path__ + "static/media/ic_fog.bbe0b537a2dda8a73cd201c5d5d23508.svg";
export { ForwardRef as ReactComponent };